"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Text_1 = __importDefault(require("../Text"));
const Layouts_1 = require("../../generic/Layouts");
const Selector_style_1 = require("./Selector.style");
//Single select
function Selector({ onChange, defaultValue, value, options, label, required }) {
    const [selectorValue, setSelectorValueAux] = react_1.useState(value);
    react_1.useEffect(() => {
        if (!value) {
            setSelectorValue(defaultValue || options[0].value);
        }
    }, []);
    const setSelectorValue = (newSelector) => {
        onChange && onChange(newSelector);
        setSelectorValueAux(newSelector);
    };
    const getComponent = (selectorValueArg) => {
        const Component = selectorValue === selectorValueArg.value ? Selector_style_1.SelectedButton : Selector_style_1.UnselectedButton;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Component, { onClick: () => {
                    setSelectorValue(selectorValueArg.value);
                }, size: "large" },
                react_1.default.createElement(Text_1.default, { size: 16, bold: selectorValue === selectorValueArg.value }, selectorValueArg.label))));
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        label && (react_1.default.createElement(Text_1.default, { padBottom: "8px", size: 13 },
            label,
            ' ',
            required && (react_1.default.createElement(Text_1.default, { span: true, primary: true, size: 20 }, "*")))),
        react_1.default.createElement(Selector_style_1.SelectorContainer, null, options.map((selectorValueTemp, index) => {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                index == 0 ? react_1.default.createElement(react_1.default.Fragment, null) : react_1.default.createElement(Layouts_1.ColumnSpacer, { width: 8 }),
                getComponent(selectorValueTemp)));
        }))));
}
exports.default = Selector;
